export const YMAPS_BLOCKED_TOAST_TEST_ID = 'YmapsBlockedToast';
